import React, { Component } from 'react'
import Cleave from 'cleave.js/react'

class CreditExpiryFieldMonth extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		const { input, label, size, meta: { valid, touched, error } } = this.props

		function handleNextField() {
			const ccYearField = document.getElementById('cc-expiry-year')

			if (ccYearField) {
				ccYearField.focus()
			}
		}

		return (
			<div className={
				touched && error ?
					'u-form-col u-form-col--error u-form-col--' + size
					: touched && valid ?
					'u-form-col u-form-col--valid u-form-col--' + size
					:
					'u-form-col u-form-col--' + size
			}>
				<Cleave
					{ ...input }
					aria-labelledby={ input.name + 'Label' }
					options={{date: true, datePattern: ['MM']}}
					onChange={(e) => e.target.value.length === 2 && handleNextField()}
					id="cc-expiry-month"
				/>
				<label id={ input.name + 'Label' }className="u-form-label u-form-label--bottom u-txt-center" htmlFor={ input.name }>{ label }</label>
				{ touched && ((error && <p className="u-font-error">{error}</p>)) }
			</div>
		)
	}
}

export default CreditExpiryFieldMonth


// WEBPACK FOOTER //
// ./src/components/forms/creditCardForm/elements/CreditExpiryFieldMonth.js